import { API_URL } from '../config';
import React, { useState, useEffect } from 'react';
import {
  Mail, RefreshCw, Settings, Eye, Send, X, Save,
  ToggleLeft, ToggleRight, ChevronDown
} from 'lucide-react';
import toast from 'react-hot-toast';
import axios from 'axios';


const AdminAcompanhamento = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // Config state
  const [config, setConfig] = useState({
    ativo: { valor: 'false' },
    modo: { valor: 'teste' },
    email_teste: { valor: '' },
    mostrar_todos: { valor: 'false' },
  });

  // Preview state
  const [showPreview, setShowPreview] = useState(false);
  const [previewHtml, setPreviewHtml] = useState('');
  const [emailTeste, setEmailTeste] = useState('');
  const [enviandoTeste, setEnviandoTeste] = useState(false);

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    carregarConfig();
  }, []);

  const carregarConfig = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/acompanhar/admin/config`, { headers });
      if (res.data && res.data.acompanhamento) {
        setConfig(res.data.acompanhamento);
      }
    } catch (error) {
      toast.error('Erro ao carregar configuracoes');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getConfigVal = (campo) => {
    return config[campo]?.valor || '';
  };

  const setConfigVal = (campo, valor) => {
    setConfig(prev => ({
      ...prev,
      [campo]: { ...prev[campo], valor }
    }));
  };

  const salvarConfig = async () => {
    setSaving(true);
    try {
      await axios.put(`${API_URL}/acompanhar/admin/config`, { acompanhamento: config }, { headers });
      toast.success('Configuracoes salvas com sucesso!');
    } catch (error) {
      toast.error('Erro ao salvar configuracoes');
      console.error(error);
    } finally {
      setSaving(false);
    }
  };

  const abrirPreview = async () => {
    try {
      const res = await axios.get(`${API_URL}/acompanhar/admin/preview`, {
        headers,
        responseType: 'text'
      });
      setPreviewHtml(res.data);
      setEmailTeste('');
      setShowPreview(true);
    } catch (error) {
      toast.error('Erro ao carregar preview');
      console.error(error);
    }
  };

  const enviarEmailTeste = async () => {
    if (!emailTeste) {
      toast.error('Informe um email para envio de teste');
      return;
    }

    setEnviandoTeste(true);
    try {
      await axios.post(`${API_URL}/acompanhar/admin/enviar-teste`, { email: emailTeste }, { headers });
      toast.success(`Email de teste enviado para ${emailTeste}`);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao enviar email de teste');
    } finally {
      setEnviandoTeste(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <RefreshCw size={32} style={{ animation: 'spin 1s linear infinite' }} />
        <p style={{ marginLeft: '10px' }}>Carregando...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '1.5rem', maxWidth: '900px', margin: '0 auto' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Mail size={28} color="var(--brand, #20a490)" />
          <div>
            <h1 style={{ fontSize: '1.5rem', fontWeight: '700', margin: 0 }}>Acompanhamento de Protocolo</h1>
            <p style={{ fontSize: '0.85rem', color: '#888', margin: 0 }}>Configuracao do email enviado ao beneficiario ao abrir atendimento</p>
          </div>
        </div>
        <button onClick={carregarConfig} style={{ padding: '8px', borderRadius: '6px', border: 'none', cursor: 'pointer', backgroundColor: '#f0f0f0' }}>
          <RefreshCw size={16} />
        </button>
      </div>

      {/* Config Card */}
      <div style={styles.configCard}>
        <div style={styles.configHeader}>
          <div>
            <h3 style={styles.configTitle}>
              <Mail size={20} color="var(--brand, #20a490)" /> Email de Acompanhamento
            </h3>
            <p style={styles.configDesc}>
              Enviado automaticamente ao beneficiario quando um atendimento e aberto.
              O email contem o protocolo e um link para acompanhamento em tempo real.
            </p>
            <button onClick={abrirPreview} style={styles.previewBtn}>
              <Eye size={14} /> Preview do email
            </button>
          </div>
          <label style={styles.toggleLabel}>
            <input
              type="checkbox"
              checked={getConfigVal('ativo') === 'true'}
              onChange={(e) => setConfigVal('ativo', e.target.checked ? 'true' : 'false')}
              style={styles.toggleInput}
            />
            <span style={{ ...styles.toggleSlider, backgroundColor: getConfigVal('ativo') === 'true' ? 'var(--brand, #20a490)' : '#ccc' }}>
              <span style={{ ...styles.toggleKnob, transform: getConfigVal('ativo') === 'true' ? 'translateX(24px)' : 'translateX(2px)' }} />
            </span>
          </label>
        </div>

        {getConfigVal('ativo') === 'true' && (
          <div style={styles.configBody}>
            {/* Modo */}
            <div style={styles.configRow}>
              <div>
                <label style={styles.fieldLabel}>Modo de envio</label>
                <p style={styles.fieldHint}>Em teste, emails vao apenas para o endereco configurado. Em producao, vao para o beneficiario real.</p>
              </div>
              <select
                value={getConfigVal('modo')}
                onChange={(e) => setConfigVal('modo', e.target.value)}
                style={styles.select}
              >
                <option value="teste">Teste</option>
                <option value="producao">Producao</option>
              </select>
            </div>

            {/* Email de teste */}
            {getConfigVal('modo') === 'teste' && (
              <div style={styles.configRow}>
                <div>
                  <label style={styles.fieldLabel}>Email de teste</label>
                  <p style={styles.fieldHint}>Todos os emails serao enviados para este endereco em modo teste</p>
                </div>
                <input
                  type="email"
                  value={getConfigVal('email_teste')}
                  onChange={(e) => setConfigVal('email_teste', e.target.value)}
                  style={styles.input}
                  placeholder="email@teste.com"
                />
              </div>
            )}

            {/* Mostrar outros atendimentos */}
            <div style={styles.configRow}>
              <div>
                <label style={styles.fieldLabel}>Mostrar outros atendimentos</label>
                <p style={styles.fieldHint}>Quando habilitado, o beneficiario vera outros atendimentos seus na pagina de acompanhamento</p>
              </div>
              <label style={styles.toggleLabel}>
                <input
                  type="checkbox"
                  checked={getConfigVal('mostrar_todos') === 'true'}
                  onChange={(e) => setConfigVal('mostrar_todos', e.target.checked ? 'true' : 'false')}
                  style={styles.toggleInput}
                />
                <span style={{ ...styles.toggleSlider, backgroundColor: getConfigVal('mostrar_todos') === 'true' ? 'var(--brand, #20a490)' : '#ccc' }}>
                  <span style={{ ...styles.toggleKnob, transform: getConfigVal('mostrar_todos') === 'true' ? 'translateX(24px)' : 'translateX(2px)' }} />
                </span>
              </label>
            </div>
          </div>
        )}
      </div>

      {/* Botao Salvar */}
      <button
        onClick={salvarConfig}
        disabled={saving}
        style={{
          display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center',
          padding: '12px 30px', backgroundColor: 'var(--brand, #20a490)', color: 'var(--brand-ink, #fff)', border: 'none',
          borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer',
          marginTop: '1.5rem', opacity: saving ? 0.7 : 1
        }}
      >
        <Save size={18} />
        {saving ? 'Salvando...' : 'Salvar configuracoes'}
      </button>

      {/* Modal Preview */}
      {showPreview && (
        <div style={styles.modalOverlay} onClick={() => setShowPreview(false)}>
          <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeader}>
              <h3 style={{ margin: 0, fontSize: '16px' }}>
                <Eye size={18} style={{ verticalAlign: 'middle', marginRight: '8px' }} />
                Preview - Email de Acompanhamento
              </h3>
              <button onClick={() => setShowPreview(false)} style={styles.modalClose}>
                <X size={20} />
              </button>
            </div>
            <div style={styles.modalBody}>
              <iframe
                srcDoc={previewHtml}
                style={{ width: '100%', height: '500px', border: 'none', borderRadius: '8px' }}
                title="Preview email"
              />
            </div>
            <div style={styles.modalFooter}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
                <input
                  type="email"
                  value={emailTeste}
                  onChange={(e) => setEmailTeste(e.target.value)}
                  placeholder="Email para envio de teste..."
                  style={{ ...styles.input, flex: 1, margin: 0 }}
                />
                <button
                  onClick={enviarEmailTeste}
                  disabled={enviandoTeste}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 20px',
                    backgroundColor: 'var(--brand, #20a490)', color: 'var(--brand-ink, #fff)', border: 'none', borderRadius: '6px',
                    fontSize: '14px', cursor: 'pointer', whiteSpace: 'nowrap',
                    opacity: enviandoTeste ? 0.7 : 1
                  }}
                >
                  <Send size={14} />
                  {enviandoTeste ? 'Enviando...' : 'Enviar teste'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  configCard: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
    overflow: 'hidden',
  },
  configHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px',
    borderBottom: '1px solid #f0f0f0',
  },
  configTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '16px',
    fontWeight: '600',
    margin: '0 0 4px 0',
  },
  configDesc: {
    fontSize: '13px',
    color: '#888',
    margin: 0,
    maxWidth: '500px',
  },
  fieldHint: {
    fontSize: '12px',
    color: '#aaa',
    margin: '2px 0 0 0',
  },
  configBody: {
    padding: '20px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  configRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
  },
  fieldLabel: {
    fontSize: '14px',
    color: '#555',
    fontWeight: '500',
    marginBottom: '2px',
    display: 'block',
  },
  input: {
    padding: '10px 14px',
    borderRadius: '6px',
    border: '1px solid #ddd',
    fontSize: '14px',
    width: '250px',
  },
  select: {
    padding: '10px 14px',
    borderRadius: '6px',
    border: '1px solid #ddd',
    fontSize: '14px',
    backgroundColor: 'white',
    width: '150px',
    cursor: 'pointer',
  },
  toggleLabel: {
    position: 'relative',
    display: 'inline-block',
    width: '50px',
    height: '26px',
    cursor: 'pointer',
    flexShrink: 0,
  },
  toggleInput: {
    opacity: 0,
    width: 0,
    height: 0,
    position: 'absolute',
  },
  toggleSlider: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: '26px',
    transition: '0.3s',
    display: 'block',
  },
  toggleKnob: {
    position: 'absolute',
    top: '2px',
    width: '22px',
    height: '22px',
    backgroundColor: 'white',
    borderRadius: '50%',
    transition: '0.3s',
    boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
  },
  previewBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 14px',
    backgroundColor: '#f0f0f0',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '13px',
    color: '#555',
    cursor: 'pointer',
    marginTop: '8px',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: '12px',
    width: '95%',
    maxWidth: '700px',
    maxHeight: '90vh',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 20px',
    borderBottom: '1px solid #eee',
  },
  modalClose: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#888',
    padding: '4px',
  },
  modalBody: {
    padding: '20px',
    overflow: 'auto',
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  modalFooter: {
    padding: '16px 20px',
    borderTop: '1px solid #eee',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
};

export default AdminAcompanhamento;
